export default {
    GET_FACILITY_EXTRA_PRICING(state, data) {
      state.facility_extra_pricing = data.data;
    },
    GET_DELETED_FACILITY_EXTRA_PRICING (state, data) {
      state.deleted_facility_extra_pricing = data.data
    },
    GET_FACILITY_COMMISSION(state, data) {
      state.facility_commission = data.data;
    },
  };
  